import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=a97dd6cc&scoped=true"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"
import style0 from "./AddOrder.vue?vue&type=style&index=0&id=a97dd6cc&prod&lang=scss&scoped=true"
import style1 from "./AddOrder.vue?vue&type=style&index=1&id=a97dd6cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97dd6cc",
  null
  
)

export default component.exports